/** @deprecated since v5. */
export enum AllowedColors {
    add = 'var(--color-group-add)',
    active = 'var(--color-group-active)',
    alert = 'var(--color-group-alert)',
    action = 'var(--color-group-action)',
    warning = 'var(--color-group-warning)',
    info = 'var(--color-group-info)',
    transfer = ' var(--color-group-transfer)',
    navigation = 'var(--color-group-navigation)',
    disabled = 'var(--color-group-disabled)'
}
